module.exports = __webpack_public_path__ + "b73ed4eb446a0ed9f84e1a042c62f71e.jpg";